import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { getPartnerDetailQueryKey } from "@/lib/react-query";
import { GetPartnerDetailData } from "@/types/partners";
import { shouldSkipPartnerCheck } from "@/utils/partner";

import { getPartnerDetail } from "./partnersApi";

export const useGetPartnerDetailAPI = (
  appSubdomain: string,
  options?: Omit<
    UseQueryOptions<GetPartnerDetailData, Error, GetPartnerDetailData>,
    "queryKey" | "queryFn"
  >
) =>
  useQuery({
    queryKey: getPartnerDetailQueryKey(appSubdomain),
    queryFn: () => getPartnerDetail(appSubdomain),
    meta: { shouldPersist: true },
    staleTime: 24 * 60 * 60 * 1000,
    enabled: !shouldSkipPartnerCheck(appSubdomain),
    ...options
  });
